import { render, staticRenderFns } from "./TileNote.vue?vue&type=template&id=374f4153&"
import script from "./TileNote.vue?vue&type=script&lang=js&"
export * from "./TileNote.vue?vue&type=script&lang=js&"
import style0 from "./TileNote.vue?vue&type=style&index=0&id=374f4153&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports